import { Skeleton } from "@/components/ui/skeleton";

/** يطابق `SavedContent`: شبكة بطاقات فيديو بنسبة 3/4 + صف أفاتار واسم */
export function SettingsSavedPageSkeleton() {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 w-full"
      aria-busy
      aria-label="Loading"
    >
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className="relative bg-white">
          <div className="relative aspect-[3/4] rounded-2xl overflow-hidden">
            <Skeleton className="w-full h-full rounded-2xl" />
          </div>
          <div className="py-3">
            <div className="flex items-center gap-2">
              <Skeleton className="h-8 w-8 rounded-full shrink-0" />
              <div className="flex-1 space-y-2 min-w-0">
                <Skeleton className="h-4 w-full max-w-[95%]" />
                <Skeleton className="h-3 w-2/3 max-w-[80%]" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

/** يطابق `AppliedJobsContent`: عنوان + مجموعات شركة + بطاقات وظيفة */
export function SettingsAppliedJobsPageSkeleton() {
  return (
    <div className="flex flex-col gap-y-6 w-full" aria-busy aria-label="Loading">
      <Skeleton className="h-7 w-48 max-w-[85%] rounded-md" />
      {[0, 1].map((group) => (
        <div key={group} className="flex flex-col gap-y-3">
          <Skeleton className="h-4 w-36 rounded-md" />
          {[0, 1].map((job) => (
            <div
              key={job}
              className="flex flex-col gap-y-2 p-4 border border-border/60 rounded-2xl bg-white/50"
            >
              <Skeleton className="h-5 w-[72%] max-w-lg rounded-md" />
              <Skeleton className="h-4 w-[45%] max-w-xs rounded-md" />
              <Skeleton className="h-4 w-40 rounded-md opacity-80" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
